import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-email-templates',
  templateUrl: './email-templates.component.html',
  styleUrls: ['./email-templates.component.scss']
})
export class EmailTemplatesComponent implements OnInit {

  emailTemplatesList:any;
  displayedColumns=['number','title','subject','action']

  pageSizeOptions:number[] = [
    20,
    50,
    100,
    200,
    500
  ];
  pageSize:number = this.pageSizeOptions[0];
  pageOffset: number = 0;
  pageIndex: number = 0;

  constructor(
    private notificationService:NotificationService,
    private router:Router
  ) { }
  
  ngOnInit(): void {
    this.getEmailTemplatesList();
  }

  getEmailTemplatesList(reset:boolean=false){
    if(reset) {
      this.pageOffset = 0;
      this.pageIndex = 0;
    }
    let filters = { limit: this.pageSize, offset: this.pageOffset};
    this.notificationService.getEmailTemplatesList(filters).subscribe(res=>{
      this.emailTemplatesList=res
    })
  }

  getEmailTemplateDetail(templateId:any){
    
  }

  onPaginationChange(e) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.pageOffset = this.pageIndex * this.pageSize;
    this.getEmailTemplatesList()
  }

}
